import { defineComponent as _defineComponent } from 'vue'
import BCXContentAreaTabs, { TabEntry } from '@/components/molecules/BCXContentAreaTabs.vue';
import useI18n from '@/mixins/useI18n';
import { computed } from 'vue';
import { useMyProjects } from '@/views/my-projects/composables/useMyProjects';
import useNotificationState from '@/state/notificationState';
import { NotificationCountType } from '@/models/Notification';
import { isProductionEnvironment } from '@/utils/isEnvironment';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyProjectsTabs',
  setup(__props) {

const { notifications } = useNotificationState();

const { hasChanges } = useMyProjects();
const { t } = useI18n();

const hasChangedOffers = computed(() => !!(
  notifications.value?.projects?.[NotificationCountType.NewProjectOffers]
    || notifications.value?.projects?.[NotificationCountType.ChangedProjectOffers]
      || hasChanges.value
));

const hasChangedContracts = computed(() => !!(notifications.value?.contracts[NotificationCountType.NewContracts]
    || notifications.value?.contracts[NotificationCountType.ChangedContracts]));

const tabs = computed(() => {
  const baseTabs:TabEntry[] = [
    {
      to: '/my-projects',
      label: `${t('my-projects.tabs.projects')}`,
      isNew: false,
    },
    {
      to: '/my-projects/offers',
      label: `${t('my-projects.tabs.offers')}`,
      isNew: hasChangedOffers.value,
      includedRouteNames: ['offersForMyProject'],
    },
    {
      to: '/my-projects/contracts',
      label: `${t('my-projects.tabs.contracts')}`,
      isNew: hasChangedContracts.value,
      includedRouteNames: ['myProjectsContract'],
    },
    {
      to: '/my-projects/invoices',
      label: `${t('my-projects.tabs.invoices')}`,
      isNew: false,
      includedRouteNames: ['myProjectsInvoice'],
      disabled: isProductionEnvironment
    }
  ];

  return baseTabs;
});

return { __sfc: true,notifications, hasChanges, t, hasChangedOffers, hasChangedContracts, tabs, BCXContentAreaTabs }
}

})